module.exports = __webpack_public_path__ + "static/zuri-hybrid-vtol-forward-flight-propulsion-cruise-mode-diagram-04ac52f410bbc54ebabfe98a456e3dd8.webp";